/* istanbul ignore file */
import React from 'react';
import { Route } from 'react-router-dom';

const TransverseRoute = ({ component: Component, roles, ...rest }: any) => {
  return <Route {...rest} render={(props) => <Component {...props} />} />;
};

export default TransverseRoute;
